import React, { useState, useEffect } from "react";
import { Modal, Typography, Button } from "antd";
import { ColorLens, CheckOutlined } from "@mui/icons-material";
import "./ColorModal.css";
import "./modalAnimations.css"; 
const { Title } = Typography;

const ColorsModal = ({
  visible,
  onCancel,
  onSave,
  metaData,
  initialSelectedColor = null, // expects an object like { id: 46, label_name: "Red", value: "#FF0000" }
}) => {
  const [selectedColorId, setSelectedColorId] = useState(null);
  const sortedMetaData = React.useMemo(() => {
  if (!metaData) return [];
  const noColorObj = { id: 9999, label_name: "No Color", value: null };
  const hasNoColor = metaData.some(c => c.label_name === "No Color" && c.value === null);
  const others = metaData.filter(c => !(c.label_name === "No Color" && c.value === null));
  return hasNoColor ? [...others, metaData.find(c => c.label_name === "No Color" && c.value === null)] : [...others, noColorObj];
}, [metaData]);
  useEffect(() => {
    // console.log("initialSelectedColor", initialSelectedColor)
    if (visible && metaData?.length > 0) {
      let defaultId = null;

      if (initialSelectedColor && typeof initialSelectedColor === "object") {
        defaultId = initialSelectedColor.id;
      } else {
        const fromMeta = metaData.find((color) => color.selected);
        defaultId = fromMeta?.id || null;
      }

      setSelectedColorId(defaultId);
    }
  }, [visible, metaData, initialSelectedColor]);

  const handleColorSelection = (id) => {
    setSelectedColorId(id);
  };

  const handleSave = () => {
    const selectedColor = metaData.find((color) => color.id === selectedColorId);
    onSave(selectedColor);
  };
  return (
    <Modal
      transitionName="fade-slide"
      maskTransitionName="fade-slide"
      title={
        <Title level={4} style={{ marginBottom: 0 }}>
          <ColorLens style={{ maxWidth: 22, marginRight: 10 }} />
          Color
        </Title>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={480}
    >
      <p>Pick a color</p>
      <div className="color-options" style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        {sortedMetaData?.map((color) => (
          <div
            key={color.id}
            className={`color-circle ${selectedColorId === color.id ? "selected" : ""}`}
            style={{
              backgroundColor: color.value || "#fff",
              width: 32,
              height: 32,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow:
                selectedColorId === color.id
                  ? "0 0 0 3px #1890ff"
                  : "0 0 0 1px #ccc",
              transition: "box-shadow 0.2s",
              border: color.label_name === "No Color" && color.value === null ? "1px dashed #aaa" : undefined,
              position: "relative"
            }}
            onClick={() => handleColorSelection(color.id)}
            title={color.label_name}
          >
            {color.label_name === "No Color" && color.value === null ? (
              <span style={{
                color: "#aaa",
                fontSize: 12,
                fontWeight: 600,
                textAlign: "center",
                width: "100%",
                userSelect: "none"
              }}>
                No<br />Color
              </span>
            ) : null}
            {selectedColorId === color.id && (
              <CheckOutlined style={{ color: color.label_name === "No Color" ? "#1890ff" : "#fff", fontSize: 16, position: "absolute" }} />
            )}
          </div>
        ))}
      </div>

      <div style={{ textAlign: "right", marginTop: 32 }}>
        <Button onClick={onCancel} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleSave} disabled={selectedColorId === null}>
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default ColorsModal;
